import useFilter from '@components/Items/utils/hooks/useFilter'
import _isArray from 'lodash/isArray'
import Pill from '@components/Items/Filters/Active/Pill'
import { QUERY_KEYS } from '@components/Items/utils/functions'

const Conditions = () => {
  const { conditionList, conditionQuery, updateQuery } = useFilter()
  if (!conditionQuery) return <></>

  if (_isArray(conditionQuery))
    return (
      <>
        {conditionQuery.map((id) => (
          <Pill
            key={`pill-location-${id}`}
            label={
              conditionList.find((condition) => Number(id) === condition.id)
                ?.name || ''
            }
            onClick={() => updateQuery(QUERY_KEYS.ITEM_CONDITION_IDS, id, true)}
          />
        ))}
      </>
    )

  return (
    <Pill
      label={
        conditionList.find(
          (condition) => Number(conditionQuery) === condition.id
        )?.name || ''
      }
      onClick={() =>
        updateQuery(QUERY_KEYS.ITEM_CONDITION_IDS, conditionQuery, true)
      }
    />
  )
}

export default Conditions
